import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Document, Page, pdfjs } from 'react-pdf'
import styled from 'styled-components'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const SharedModal = styled(Modal)`
  .react-pdf__Page__canvas {
    width: 100% !important;
    height: initial !important;
  }

  .pdfPageSelector {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    background: #2d2c3c;
    button {
      color: white;
      background: transparent;
      font-size: 12px;
      border: solid 1px white;
      margin: 0 8px;
      border-radius: 8px;
      padding: 1px 6px;
      &:hover {
        background: white;
        color: #2d2c3c;
      }
    }
  }
  .modal-header {
    .modal-title {
      color: white;
      font-size: 18px;
    }
    p.file-description {
      font-size: 18px;
      margin: 0;
      font-weight: 600;
    }
    .close {
      opacity: 1;
      z-index: 100;
      span {
        font-weight: 400;
        font-size: 38px;
        color: #fff;
      }
    }
  }
  .modal-content {
    background: rgba(0, 0, 0, 0.7);
  }
  .modal-body, .modal-footer {
    padding: 0;
  }
  .download-btn {
    display: block;
    background: #2E3080;
    border-radius: 6px;
    border: none;
    text-decoration: none;
    color: #fff;
    padding: 10px 24px;
    font-weight: 800;
    font-size: 80%;
    cursor: pointer;
    height: 100%;
    min-width: 150px;
    margin: auto;
  }
`


export const DocumentViewer = ({ file, setDocumentSelected }) => {
  const [pdfPages, setPdfPages] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)

  return (
    <SharedModal show={true} onHide={() => setDocumentSelected(null)} size="lg" aria-labelledby="gallery-pdf-modal" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <b>{file?.title}</b>
          <p className="file-description">{file?.filename}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          {/* <div className='text-light text-center font-weight-bold'>
            To download a soft copy, please visit <a href="https://imfed.my" target="_blank">https://imfed.my</a>
          </div> */}
          <Document
            file={file?.url}
            loading={<p className="text-center text-white mt-3">Loading pdf...</p>}
            onLoadSuccess={({ numPages }) => {
              setPdfPages(numPages)
            }}
          >
            <Page pageNumber={currentPage} />
          </Document>
          {typeof pdfPages === 'number' && pdfPages > 1 && (
            <div className="pdfPageSelector">
              {Array.from({ length: pdfPages }).map((_, index) => (
                <button
                  onClick={() => {
                    setCurrentPage(index + 1)
                  }}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}
        </>
      </Modal.Body>
    </SharedModal>
  )
}
